<template>
    <div class="refundsBox">
        <div @click="exportExcel">
            <el-button type="primary">导出数据</el-button>
        </div>
        <el-form size="medium" class="mt20" :inline="true">
            <el-form-item label="退款状态:">
                <el-select style="width:178px;" v-model="params.status" @change="handlePageChange(1)">
                    <el-option v-for="item in stateData" :key="item.key" :label="item.value" :value="item.key"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-date-picker v-model="timeDate" type="daterange" range-separator="至" start-placeholder="申请开始时间" end-placeholder="申请结束时间" @change="handlePageChange(1)" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-input @keyup.enter.native="handlePageChange(1)" placeholder="请输入订单号搜索" v-model="params.orderSn" ></el-input>
            </el-form-item>
            <el-form-item>
                <el-input @keyup.enter.native="handlePageChange(1)" placeholder="请输入票品ID搜索" v-model="params.ticketNo" ></el-input>
            </el-form-item>
            <el-form-item>
                <el-input @keyup.enter.native="handlePageChange(1)" placeholder="请输入退款单号搜索" v-model="params.refundNo" ></el-input>
            </el-form-item>
            <el-form-item>
                <el-input @keyup.enter.native="handlePageChange(1)" placeholder="请输入退款用户手机号搜索" v-model="params.mobile" ></el-input>
            </el-form-item>
        </el-form>
        <el-table :data="refundsList" border style="width: 100%">
            <el-table-column label="退款信息" min-width="300">
                <template slot-scope="scope">
                    <p>退款单号：{{scope.row.refundNo}}</p>
                    <p>订  单   号：{{scope.row.orderSn}}</p>
                    <p>退款状态：{{status[scope.row.status]}}</p>
                    <p v-if="scope.row.applyStartDateTime">申请退款：{{scope.row.applyStartDateTime | formatDate}}</p>
                    <p v-else>申请退款：无</p>
                    <p v-if="scope.row.confirmRefundDateTime">确认退款：{{scope.row.confirmRefundDateTime | formatDate}}</p>
                    <p v-else>确认退款：无</p>
                    <p v-if="scope.row.closeRefundDateTime">退款关闭：{{scope.row.closeRefundDateTime | formatDate}}</p>
                    <p v-else>退款关闭：无</p>
                    <p v-if="scope.row.failRefundDateTime">退款失败：{{scope.row.failRefundDateTime | formatDate}}</p>
                    <p v-else>退款失败：无</p>
                </template>
            </el-table-column>
            <el-table-column label="退款活动" align="center" min-width="300">
                <template slot-scope="scope">
                    <div class="flexBox">
                        <img :src="scope.row.activityImg" alt="" style="width: 100px;">
                        <div class="flexBoxContent">
                            <p>{{scope.row.activityName}}</p>
                            <p>{{scope.row.activityAddress}}</p>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="退款票品" width="300">
                <template slot-scope="scope">
                    <p>票品ID：{{scope.row.ticketNo}}</p>
                    <p>票品类型：{{scope.row.tickedType}}</p>
                    <p>票品名称：{{scope.row.tickedName}}</p>
                    <p>票品价格：{{scope.row.ticketPrice}}</p>
                </template>
            </el-table-column>
            <el-table-column label="退款金额" width="150">
                <template slot-scope="scope">
                    <!-- <p>退款数量：{{scope.row.orderNumber}}</p> -->
                    <p>退款数量：1</p>
                    <p>退款金额：{{scope.row.ticketPrice}}</p>
                    <p>退款渠道：{{scope.row.refundChannel}}</p>
                </template>
            </el-table-column>
            <el-table-column label="退款用户" width="150">
                <template slot-scope="scope">
                    <p>用户ID：{{scope.row.wxUserId}}</p>
                    <p>用户昵称：{{scope.row.wxUserNickName}}</p>
                    <p>手机号：{{scope.row.wxUserMobile}}</p>
                </template>
            </el-table-column>
            <el-table-column label="更新时间" min-width="150">
                <template slot-scope="scope">
                    <span>{{scope.row.updatedAt | formatDate}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="180">
                <template slot-scope="scope">
                    <el-button size="mini" v-if="scope.row.status == 7" @click="config(scope.row.id, 0)">通过</el-button>
                    <el-button size="mini" v-if="scope.row.status == 7" type="danger" @click="reject(scope.row.id)">不通过</el-button>
                    <el-button size="mini" v-if="scope.row.status == 9" type="danger" @click="config(scope.row.id, 1)">重新发起</el-button>
                </template>
            </el-table-column>
        </el-table>
        <table-pagination :pageTotal="tableTotal" @handlePageChange="handlePageChange" />
        <audit-modal ref="auditModal" @loadData="handlePageChange"></audit-modal>
    </div>
</template>

<script>
import { urlObjectParams, dateToString } from '@/utils';
import refunds from '@/services/finance/refunds'
import AuditModal from './components/AuditModal';
import { prefix } from '@/api';
import axios from 'axios';
export default {
    components: { AuditModal },
    data() {
        return {
            timeDate: [],
            params: {
                status: ''
            },
            page: {
                pageNumber: 1,
                pageSize: 10
            },
            tableTotal: 0,
            stateData: [
                {
                    key: '',
                    value: '全部'
                }, {
                    key: 7,
                    value: '退款申请中'
                }, {
                    key: 4,
                    value: '退款成功'
                }, {
                    key: 8,
                    value: '退款关闭'
                }, {
                    key: 9,
                    value: '退款失败'
                }
            ],
            status: {
                0: '未支付',
                1: '已支付',
                2: '支付失败',
                3: '取消订单',
                4: '退款成功',
                5: '已核销',
                6: '正在支付，等待回调',
                7: '退款申请中',
                8: '退款关闭',
                9: '退款失败',
                10: '部分退款成功',
                11: '部分退款申请中',
                12: '部分退款关闭',
                13: '部分退款失败',
                14: '微信退款中',
            },
            refundsList: []
        }
    },
    created() {
        console.log(process.env.NODE_ENV)
        this.getRefundsList()
    },
    methods: {
        getRefundsList() {
            refunds.refundsList({ ...this.params, ...this.page, applyStartDateTime: this.timeDate ?this.timeDate[0] : '', applyEndDateTime: this.timeDate ? this.timeDate[1] : '' }).then(res => {
                this.refundsList = res.result.data;
                this.tableTotal = res.result.total
            })
        },
        config(id, type) {
            let text = [
                '点击将发起退款，请确定是否操作？点击【确定】对该笔退款单发起第三方支付渠道退款',
                '点击将发起退款，请确定是否操作？对该笔退款单重新发起第三方支付渠道退款',
            ]
            const h = this.$createElement;
			this.$msgbox({
				title: '提示',
				message: h('p', null, text[type]),
				showCancelButton: true,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				beforeClose: (action, instance, done) => {
					if (action === 'confirm') {
						instance.confirmButtonLoading = true;
						instance.confirmButtonText = `操作中...`;
						refunds.refundConfirm({ id }).then(res => {
                            if (Object.is(res.code, 0)) {
                                done();
                                console.log(res.code)
                                instance.confirmButtonLoading = false;
                                instance.confirmButtonText = '确定';
                                this.$message.success('操作成功')
                                this.getRefundsList()
                            } else {
                                done();
                                instance.confirmButtonLoading = false;
                                instance.confirmButtonText = '确定';
                                this.$message.error(res.message);
                            }
                        })
					} else {
						done();
						instance.confirmButtonLoading = false;
						instance.confirmButtonText = '确定';
					}
				}
			})
        },
        reject(id) {
            this.$refs.auditModal.openModal(id);
        },
        exportExcel() {
            let queryOptions = {
                ...this.params,
                applyStartDateTime: this.timeDate ?this.timeDate[0] : '',
                applyEndDateTime: this.timeDate ? this.timeDate[1] : ''
            };
            axios({
                method: 'get',
                url: `${prefix}/admin/order_refund/export_excel?${urlObjectParams(queryOptions)}`,
                responseType: 'blob'
            }).then(data => {
                const blob = new Blob([data], { type: 'application/ms-excel' });
                const elink = document.createElement('a');
                elink.download = `退款记录${dateToString(new Date())}.xlsx`;
                elink.style.display = 'none';
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }).catch(() => {
                // this.isShowDownload = false;
            })
        },
        handlePageChange(val) {
            console.log(this.timeDate)
            this.page.pageNumber = val;
            this.getRefundsList()
        }
    },
}
</script>

<style lang="scss" scoped>
.flexBox{
    display: flex;
    padding: 0 10px;
    .flexBoxContent{
        flex: 1;
        text-align: left;
        margin-left: 10px;
        margin-top: 30px;
        line-height: 1.5;
    }
}
</style>
